module.exports = __webpack_public_path__ + "static/media/wine_bg.09988214.jpg";